class QFCustomFilter {

    constructor(settings = {}){


        // init element classes
        this.container = settings.container ? settings.container : "post-container";
        this.item = settings.item ? settings.item : "post";
        this.itemID = settings.itemID  ? settings.itemID : "data-post-id";
        this.noPosts = settings.noPosts ? settings.noPosts : "custom-filter-no-posts";
        this.loadMore = settings.loadMore ? settings.loadMore : "custom-filter-load-more";
        this.filterContainer = settings.filterContainer ? settings.filterContainer : "filter-container";
        this.sortContainer = settings.sortContainer ?  settings.sortContainer : "sort-container"

        // get element ref
        this.containerEl = document.querySelector(`.${this.container}`)
        this.loadMoreEl = document.querySelector(`.${this.loadMore}`)
        this.noPostsEl = document.querySelector(`.${this.noPosts}`)
        this.filterContainerEl = document.querySelector(`.${this.filterContainer}`)
        this.sortContainerEl = document.querySelector(`.${this.sortContainer}`)

        // get formatted post data
        this.postData  = settings.postData ? settings.postData : {};

        // get filtter settings
        this.filterSettings = settings.filterSettings ? settings.filterSettings : {};

        // get post limits
        this.postsToShow = settings.postsToShow ? settings.postsToShow : 32;
        this.loadMoretoShow = settings.loadMoretoShow ? settings.loadMoretoShow : this.postsToShow;

        // get additional options
        //this.buildFilters = settings.buildFilters == 'false' ? false : true;

        this.filterOptions = {};
        this.allPostHtml = {};
        this.currentPostHtml = {};
        this.allowedSortMethods = [
            'default',
            'title_asc',
            'title_dsc',
            'created_at_asc',
            'created_at_dsc',
            'price_asc',
            'price_dsc',
        ]


        this.sortMethod = 'default';


        this.init()

    }


    // PRIVATE FUNCTIONS ---

    init(){
        //window.log(`postData:`, this.postData)

        this.buildAdditionalElements()
        this.storePostHtml()
        this.buildFilters()
        this.urlFilters()
        this.setUpListeners()

        this.showPosts();

        let wrapper = document.getElementById("qf-filter-wrapper")
        wrapper.style.overflow = 'unset'
        wrapper.style.maxHeight = 'unset'
    }

    buildAdditionalElements() {

        // check for no container element
        if(!this.containerEl){
            //window.log(`%cQFCustomFilter: ERROR - No element with class ${this.container} found. Please ensure the element exists.`, 'color: red; background: black; padding: 6px;')
            return false;
        }

        // check for load more element
        if(!this.loadMoreEl){
            //window.log(`%cQFCustomFilter: WARNING - No element with class ${this.loadMore} found. All posts will be shown be default.`, 'color: orange; background: linear-gradient(45deg, rgba(28,87,126,1) 0%, rgba(70,54,122,1) 100%); padding: 6px;')
            this.postsToShow = Number.MAX_SAFE_INTEGER // if no load more exists show all posts by default
        }

        // check for no posts element
        if(!this.noPostsEl){
            //window.log(`%cQFCustomFilter: WARNING - No element with class ${this.noPosts} found. No message will be shown when search criteria returns no results.`, 'color: orange; background: linear-gradient(45deg, rgba(28,87,126,1) 0%, rgba(70,54,122,1) 100%); padding: 6px;')
        } else {
            // hide no posts
            this.noPostsEl.style.display = 'none'
        }


    }

    storePostHtml() {
        // Store allPostHtml ---
        let filter = this

        let posts = document.querySelectorAll(`.${this.container} .${this.item}`);

        posts.forEach((el, i) => {
            let id = el.getAttribute(`${filter.itemID}`)
            filter.allPostHtml[id] = el;
        })

        this.currentPostHtml = this.allPostHtml;

        //window.log("HTML:", this.currentPostHtml)
    }


    buildFilters() {
        // Build filters ---
        let filter_html = '';
        Object.keys(this.filterSettings).forEach((theme, i) => {

            // window.log("type", typeof this.filterSettings[theme])
            // window.log("settings", this.filterSettings[theme])
            // window.log("theme", theme)

            if(this.filterSettings[theme].length > 0){

                var labelTheme = theme.replace(/_/g, ' ');

                filter_html += `
                                <div class="custom-filter" data-theme="${theme}" style="display: flex; flex-direction: column">
                                    <p class="filter-heading" style="text-transform: capitalize">
                                        ${labelTheme}
                                    </p>
                                    <div class="custom-filter-checkboxes">
                                `;

                let terms = this.filterSettings[theme]
                terms.forEach((term) => {
                    filter_html += `
                                    <div class="field__checkbox">
                                        <label class="field__label">
                                            ${term}
                                            <input type="checkbox" data-theme="${theme}" data-term="${term}" >
                                            <span></span>
                                        </label>
                                    </div>`;
                })

                filter_html += '</div></div>';
            }
        })

        // Add filter container if none exists
        if(!this.filterContainerEl){

            let filterContainer = document.createElement('div')
            filterContainer.classList.add(this.filterContainer)
            // filterContainer.style.display = 'flex'
            this.containerEl.parentNode.insertBefore(filterContainer, this.containerEl)

            this.filterContainerEl = filterContainer
        }

        // Add filters to container
        this.filterContainerEl.append(this.htmlToElement(filter_html))

    }

    setUpListeners() {

        let filter = this

        // Listen for filter option changes ---
        let filterCheckboxes = document.querySelectorAll(`.${this.filterContainer} input[type=checkbox]`)

        filterCheckboxes.forEach((el) => {

            el.addEventListener('change', () => {
                let checked = el.checked;

                let theme = el.getAttribute("data-theme")
                let term = el.getAttribute("data-term")

                window.log("THEME:", theme)
                window.log("TERM:", term)

                if(checked){

                    if(!filter.filterOptions.hasOwnProperty(theme)){
                        filter.filterOptions[theme] = [];
                    }

                    filter.filterOptions[theme].push(term);
                    // filterOptionsCount++
                } else {
                    let index = filter.filterOptions[theme].indexOf(term);
                    if (index > -1) {
                        filter.filterOptions[theme].splice(index, 1);
                        // filterOptionsCount--
                    }
                }

                window.log("Filter Options:", filter.filterOptions)
                filter.showPosts()

            })


        })


        // Load More ---
        this.loadMoreEl.addEventListener('click', () => {
            filter.postsToShow += filter.loadMoretoShow;
            filter.showPosts();
        })


        // Sort
        if(this.sortContainerEl){
            let sort_select = document.querySelector(`.${this.sortContainer} select`)

            sort_select.addEventListener('change', () => {
                let sortMethod = sort_select.value
                if(this.allowedSortMethods.includes(sortMethod)){
                    this.sortMethod = sortMethod
                    filter.showPosts()

                } else {
                    window.log(`${sortMethod} is not a vaild sort option`)
                }
            })
        }


    }

    getPosts(){

        // Show all if if no filter options have been selected
        var filterOptionsCount = 0;
        for(let key in this.filterOptions){
            filterOptionsCount += this.filterOptions[key].length;
        }

        if(filterOptionsCount == 0){
            return this.allPostHtml;
        } else {
            return this.filterPosts();
        }

    }

    filterPosts(){

        // find posts that match filter options
        let filtered_posts = [];

        // window.log("FILTER OPTIONS: ", this.filterOptions)

        for(let key in this.postData){

            // window.log(">",key)

          	let found = true;
            // window.log("PRODUCT DATA", this.postData[key])
            for(let theme in this.postData[key]){
                let terms = this.postData[key][theme]
                // window.log(">>>", theme)

                if(this.filterOptions.hasOwnProperty(theme) && this.filterOptions[theme].length > 0){
                	found = this.filterOptions[theme].some(el => terms.indexOf(el) >= 0)
                }

                if(!found){
                	break;
                }
            }

            if(found){
                filtered_posts.push(key)
            }

        }

        window.log("FILTERED: ", filtered_posts, "Length: ", filtered_posts.length)

        let filteredPostHtml = {};

        filtered_posts.forEach(postId => {
            filteredPostHtml[postId] = this.allPostHtml[postId];
        });

        return filteredPostHtml;

    }

    urlFilters(){

        let queryString = window.location.search;

        if(queryString != ''){
            let queryParts = queryString.substring(1).split('&')
            let urlQuery = {}

            queryParts.forEach((part) => {
                let themeQuery = part.split('=')
                let searchTheme  = themeQuery[0];
                let searchTerms  = themeQuery[1].split('+');
                searchTerms = searchTerms.map((term) => {
                    return decodeURIComponent(term)
                })

                urlQuery[searchTheme] = searchTerms


            })



            for(let theme in this.filterSettings){

                let searchTerms = Object.keys(urlQuery).includes(theme) ? urlQuery[theme] : null

                if(searchTerms){

                    searchTerms.forEach((term) => {

                        // if term is a valid setting, add to options
                        let termsForTheme = this.filterSettings[theme]

                        window.log("term", term, termsForTheme)


                        if(Object.values(termsForTheme).includes(term)){

                            // init as array if not yet defined
                            if(!this.filterOptions[theme]){
                                this.filterOptions[theme] = [];
                            }

                            // Add term to filter options
                            this.filterOptions[theme].push(term)

                            // check relevant checkbox
                            let termInput = document.querySelector(`[data-theme="${theme}"][data-term="${term}"]`)
                            termInput.checked = true


                        }

                    })

                }

            }

        }




    }

    setUrlParams(){

        if(Object.keys(this.filterOptions).length > 0){
            let searchParams = '?'

            // console.log("OPT:", this.filterOptions)

            for(let theme in this.filterOptions){
                searchParams = searchParams + `${theme}=`
                let terms = this.filterOptions[theme]
                terms = terms.map((term) => {
                    return encodeURIComponent(term)
                })
                // console.log(">terms", terms)
                terms = terms.join('+')
                // console.log(">>terms", terms)
                // terms = encodeURI(terms)
                // console.log(">>>terms", terms)

                searchParams = searchParams + terms + "&"

            }

            searchParams = searchParams.substring(0, searchParams.length - 1)
            // console.log("NEW PARAMS:", searchParams)

            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + searchParams;
            window.history.pushState({path:newurl},'',newurl);
        }

    }


    showPosts(){

        window.log("SHOWING POSTS")

        // Set currentPostHtml
        let postHtml = this.getPosts()
        this.currentPostHtml = postHtml;



        this.clearPosts();

        let postsAdded = 0;
        let i = 0;

        if(this.sortMethod != 'default'){

            let sortOrder = this.sortPosts(postHtml);
            for(let i = 0; i < sortOrder.length; i++){
                // if(i >= toShowLowerLimit){
                //     $(postContainer).append(postHtml[sortOrder[i]])
                //     postsAdded++
                // }

                this.containerEl.append(postHtml[sortOrder[i]])
                postsAdded++

                if(postsAdded >= this.postsToShow){ break; }
            }

        } else {

            let productIds = Object.keys(postHtml)
            for(let i = 0; i < productIds.length; i++){

                this.containerEl.append(postHtml[productIds[i]])
                postsAdded++

                if(postsAdded >= this.postsToShow){ break; }
            }

        }

        // Show/Hide no posts message
        if(postsAdded == 0){
            this.noPostsEl.style.display = 'table'
        } else {
            this.noPostsEl.style.display = 'none'
        }


        // Show/Hide load more
        let totalPostCount = Object.keys(postHtml).length;

        if(totalPostCount <= this.postsToShow){
            this.loadMoreEl.style.display = 'none'
        } else {
            this.loadMoreEl.style.display = 'table'

        }

        this.setUrlParams()

        // Product cards
        let productCardShowVariants = document.querySelectorAll('.js-card-show-variants');
        productCardShowVariants.forEach((showVariant) => {
            showVariant.addEventListener('click', function(e) {
                e.preventDefault();

                const selectWrapper = showVariant.parentElement.querySelector('.select-wrapper');

                showVariant.classList.add('hidden');
                selectWrapper.classList.add('active');
            })
        })

        // Quick add buttons -- START
        let quickAdds = document.querySelectorAll('[quick-add-qf]')
        for(let i = 0; i < quickAdds.length; i++){
            let current = quickAdds[i]
            let data = current.dataset

            current.addEventListener('click', function(e){
                e.preventDefault()

                let quantity = data.quantity
                let id = data.id

                if(id && quantity && quantity > 0){
                    window.qf_cart.addToCart(id, quantity)
                }
            })
        }
        // Quick add buttons -- END

        // Product Forms -- START
        let productForms = document.querySelectorAll('[action="/cart/add"]')

        for(let i = 0; i < productForms.length; i++){
            let productForm = productForms[i]
            let data = productForm.dataset

            productForm.addEventListener('submit', function(e){

                e.preventDefault()

                let quantity = productForm.querySelector("input.quantity-selector").value
                let id = productForm.querySelector("#product-id").value

                if(quantity && id){

                    window.qf_cart.addToCart(id, quantity,)
                }

            })

        }
        // Product Forms -- END

        return postHtml
    }

    sortPosts(postHtml){
        // window.log("SORTING")

        let sortOrder = Object.keys(postHtml);

        // window.log("ORDER BEFORE", sortOrder)

        switch(this.sortMethod){
            case 'created_at_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['created_at'] - this.postData[b]['created_at'];
                })
                break;
                
            case 'created_at_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['created_at'] - this.postData[a]['created_at'];
                })
            break;

            case 'price_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['price'] - this.postData[b]['price'];
                })
                break;

            case 'price_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['price'] - this.postData[a]['price'];
                })
                break;

            case 'title_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['title'].localeCompare(this.postData[b]['title']);
                })
                break;

            case 'title_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['title'].localeCompare(this.postData[a]['title']);
                })
                break;

            // case 'favourites':
            //     sortOrder.sort(function(a,b){
            //         return this.postData[b]['is_favourite'] - this.postData[a]['is_favourite'];
            //     })
            //     break;

            // case 'collab':
            //     sortOrder.sort(function(a,b){
            //         return this.postData[b]['is_collab'] - this.postData[a]['is_collab'];
            //     })
            //     break;
        }

        // window.log("ORDER AFTER", sortOrder)

        return sortOrder;
    }

    // HELPER FUNCITONS

    // Takes an html sting and returns it as an element
    htmlToElement(html) {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content;
    }


    // PUBLIC FUNCTIONS
    clearPosts(){
        let posts = document.querySelectorAll(`.${this.container} .${this.item}`);

        posts.forEach((el, i) => {
            el.parentNode.removeChild(el)
        })

    }

}
